export interface SnackData {
  // по дефолту - дарк
  theme?: SnackTheme;
  // как долго провисит снэк
  delay?: number;
  // заголовок текстового снэка
  title?: string;
  // текст текстового снэка
  text?: string;
  // валидная html строка
  html?: string;
  // кнопка
  button?: SnackButton;
  // id кастомного темплейта для сожержимого снэка
  template?: string;
  // колбэк, который выполнится при закрытии снэка
  onClose?: (id: string) => void;
  // колбэк, который выполнится при закрытии снэка по таймауту
  onTimeout?: (id: string) => void;
  // сюда можно передавать любые дополнительные данные
  customProps?: any;
}

export interface SnackButton {
  label: string;
  onClick: (id: string) => void;
  // предотвратить закрытие снека после клика на кнопку
  preventClose?: boolean;
}

export interface Snack extends SnackData {
  id: string;
}

export enum SnackTheme {
  Yellow = 'yellow',
  White = 'white',
  Gray = 'gray',
  Dark = 'dark',
}
